import React from 'react';

interface TabItem {
    label: React.ReactNode;
    key: string;
}

interface TabBoardProps {
    activeKey: string;
    onChange: (key: string) => void;
    items: TabItem[];
    style?: React.CSSProperties;
    tabBarStyle?: React.CSSProperties;
}

const TabBoard: React.FC<TabBoardProps> = ({
    activeKey,
    onChange,
    items,
    style,
    tabBarStyle,
}) => {
    return (
        <div style={style}>
            <div
                style={{
                    display: 'flex',
                    backgroundColor: '#F2F6FD',
                    padding: '3px',
                    ...tabBarStyle,
                }}
            >
                {items.map((item) => (
                    <div
                        key={item.key}
                        onClick={() => onChange(item.key)}
                        style={{
                            flex: 1,
                            textAlign: 'center',
                            padding: '18px 16px',
                            cursor: 'pointer',
                            transition: 'all 0.3s ease',
                            backgroundColor: activeKey === item.key ? 'white' : 'transparent',
                            color: activeKey === item.key ? 'black' : 'black',
                            borderRadius: '100px',
                            userSelect: 'none',
                            boxShadow: activeKey === item.key ? '0 2px 8px lightgray' : 'none',
                        }}
                    >
                        {item.label}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TabBoard;
